import { render, staticRenderFns } from "./McsModalComponent.vue?vue&type=template&id=2ee8918d&"
import script from "./McsModalComponent.vue?vue&type=script&lang=js&"
export * from "./McsModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./McsModalComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports